module.exports = __webpack_public_path__ + "img/symbol-i-right.7b83eaef.png";